"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    loanProductSlug: zod_1.z
        .string()
        .describe('In Limited Partner terminology this is same as fund tape, and will have 1:1 relationship with the creditFacility (Fund).'),
    creditFacilitySlug: zod_1.z
        .string()
        .describe('Identifies the fund in Limited Partner terminology'),
    externalReceivableIdField: zod_1.z
        .string()
        .describe('Identifies the field in the input tape that is unique for the receivable (LP commitment) and can be treated as externalReceivableId'),
    limitedPartnerNameAliasField: zod_1.z
        .string()
        .describe('Each facility may have a different alias for the limited partner, This field (or column) will be used to identify the limited partner alias for the tape. This will be used later to help match the alias to the actual limited partner.'),
});
exports.nodeType = 'file_limitedPartnersTape';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    creditFacilitySlug: true,
    loanProductSlug: true,
});
exports.artifactType = 'limitedPartnersTape';
//# sourceMappingURL=types.js.map